import {
  Box,
  Modal,
  Divider,
} from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";

interface CustomModalProps {
  title: string;
  body: string;
  open: boolean;
  onClose: () => void;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 310,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
};

export const CustomModal = (props: CustomModalProps) => {
  return (
    <Modal {...props}>
      <Box sx={style}>
        <Box sx={{ padding: "20px 25px" }}>
          <ByzMuiTypography variant="h6">{props.title}</ByzMuiTypography>
          <ByzMuiTypography variant="body2" color="text.secondary">
            {props.title}
          </ByzMuiTypography>
        </Box>
        <Divider />
        <Box sx={{ padding: "10px 0px" }}>
          {props.body}
        </Box>
      </Box>
    </Modal>
  );
};
